import { Component, OnInit, OnChanges, SimpleChanges, Inject, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpAuth } from '../../services/http-auth.service';
import { JobOffersService } from '../../services/job-offers.service';
import { JobsOffer } from '../../models/jobs-offer';
import { KanbanOfferStore } from '../state/kanban-offer.store';
import { KanbanOfferStoreList } from '../state/kanban-offer-list.store';
import { MdDialog } from '@angular/material';
import { ViewCvComponent } from '../view-cv/view-cv.component';
import { InviteService } from '../../services/invite.service';
import { ItemCandidateInviteComponent } from '../item-candidate-invite/item-candidate-invite.component';
import { KanbanComponent } from '../kanban/kanban.component';
import { CandidateService } from '../../services/candidate.service';
import { ApplyStatusService } from '../../services/apply-status.service';
import { InviteComponent } from '../invite/invite.component';
import { Constants } from '../constants';
import { ConfirmDeleteDialogComponent } from '../confirm-delete-dialog/confirm-delete-dialog.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-view-job',
  templateUrl: './view-job.component.html',
  styleUrls: ['./view-job.component.css']
})
export class ViewJobComponent implements OnInit {

  check_mandatory:boolean;

  TYPE_QUESTION_SN = 1;
  TYPE_QUESTION_TEXT = 2;
  TYPE_QUESTION_NUMBER = 3;

  jobId: string;
  job: JobsOffer;
  viewinvite: boolean;
  invitations: any;

  applyStatusList:any;
  users: any;
  usersFormReq: any;
  usersNotFormReq: any;

  usersReq: any;
  usersNotReq: any;

  checkMandatoryReq: boolean;
  checkMandatoryformReq: boolean;

  errorMessage: string;

  listPending: any;

  initialized: boolean;
  maxCandidates: number = 10000;

  invite: boolean;

  loading_job: boolean;

  public STATUS = Constants;

  constructor(
    private route: ActivatedRoute,
    private jobService: JobOffersService,

    @Inject(KanbanOfferStoreList) public KanbanOfferStoreList,
    private dialog: MdDialog,
    private candidateService: CandidateService,
    private applyStatusService: ApplyStatusService
  ) { }

  ngOnInit() {
    // TODO: get users invite to jobId

    this.loading_job = true;
    this.invite = true;
    this.KanbanOfferStoreList.restore();
    this.check_mandatory = true;
    this.checkMandatoryReq = true;
    this.checkMandatoryformReq = true;
    this.usersReq = [];
    this.usersNotReq = [];
    this.usersFormReq = [];
    this.usersNotFormReq = [];
    this.KanbanOfferStoreList.list = [];

    this.applyStatusService.getApplyStatus().subscribe(
        data => {
          this.applyStatusList = data;
          this.route.params.subscribe(params => {
            this.jobId = params['jobId'];
            if (typeof this.jobId != 'undefined') {
              this.viewinvite = true;
              this.jobService.getOffersById(this.jobId).subscribe(
                data => {
                  this.job = data;
                  this.loading_job = false;
                },
                error => {
                  this.errorMessage = <any>error;
                  this.loading_job = false;
                }
              );
              this.loadList();
              this.initialized = true;
            }
          });
          this.jobService.event.subscribe((data: JobsOffer) => {
            this.loadList();
          });
        },
        error => {
          this.errorMessage = <any>error;
        }
      );
  }

  loadList() {
    // Request Postulados
    let status = {
      applied: true,
      rejected: false,
      read: true,
      unread: true,
      screening: true,
      interview: true,
      test: true,
      selected: false,
      hired: false,
      configurable: false,
    };

    this.KanbanOfferStoreList.list = [];

    // Request Applied

    let kanban:KanbanOfferStore = new KanbanOfferStore(this.candidateService);
    kanban.changeFilters(status, 1, this.maxCandidates, this.jobId, true, true);
    kanban.statusName("Postulados");
    kanban.statusID(100);
    kanban.statusCustom(false);
    this.KanbanOfferStoreList.list.push(kanban);
    //this.offerStoreAppliedReq.changeFilters(status, 1, this.maxCandidates, this.jobId, true, true);


    kanban = new KanbanOfferStore(this.candidateService);
    kanban.changeFilters(status, 1, this.maxCandidates, this.jobId, true, false);
    kanban.statusName("Postulados que no cumplen");
    kanban.statusID(100);
    kanban.statusCustom(false);
    this.KanbanOfferStoreList.notfullfill =  kanban ;
    //this.offerStoreAppliedNotReq.changeFilters(status, 1, this.maxCandidates, this.jobId, true, false);

    this.applyStatusList.forEach(element => {
      let status = {
        applied: false,
        rejected: false,
        read: false,
        unread: false,
        screening: false,
        interview: false,
        test: false,
        selected: false,
        hired: false,
        configurable: true,
        item_conf: element.id
      };
      let kanban:KanbanOfferStore = new KanbanOfferStore(this.candidateService);
      kanban.changeFilters(status, 1, this.maxCandidates, this.jobId);
      kanban.statusName(element.name);
      kanban.statusID(element.id);
      kanban.statusCustom(true);
      this.KanbanOfferStoreList.list.push(kanban);
    });

    // Request Preselected
    status = {
      applied: false,
      rejected: false,
      read: false,
      unread: false,
      screening: false,
      interview: false,
      test: false,
      selected: true,
      hired: false,
      configurable: false,
    };

    // preseleccionados

    // Request Rejected
    status = {
      applied: false,
      rejected: true,
      read: false,
      unread: false,
      screening: false,
      interview: false,
      test: false,
      selected: false,
      hired: false,
      configurable: false,
    };

    kanban = new KanbanOfferStore(this.candidateService);
    kanban.changeFilters(status, 1, this.maxCandidates, this.jobId);
    kanban.statusName("Pre Seleccionados");
    kanban.statusID(275);
    kanban.statusCustom(false);
    this.KanbanOfferStoreList.list.push(kanban);
    // this.offerStorePreselected.changeFilters(status, 1, this.maxCandidates, this.jobId);
    //this.offerStoreArray.push(this.offerStorePreselected);

    // Request Rejected
    status = {
      applied: false,
      rejected: true,
      read: false,
      unread: false,
      screening: false,
      interview: false,
      test: false,
      selected: false,
      hired: false,
      configurable: false,

    };

    // Rejected
    kanban = new KanbanOfferStore(this.candidateService);
    kanban.changeFilters(status, 1, this.maxCandidates, this.jobId);
    kanban.statusName("Rechazados");
    kanban.statusID(-1);
    kanban.statusCustom(false);
    this.KanbanOfferStoreList.list.push(kanban);
    // this.offerStoreRejected.changeFilters(status, 1, this.maxCandidates, this.jobId);


    // Request Hired
    status = {
      applied: false,
      rejected: false,
      read: false,
      unread: false,
      screening: false,
      interview: false,
      test: false,
      selected: false,
      hired: true,
      configurable: false,
    };

    // Request Hired
    status = {
      applied: false,
      rejected: false,
      read: false,
      unread: false,
      screening: false,
      interview: false,
      test: false,
      selected: false,
      hired: true,
      configurable: false,

    };

    // Hired
    kanban = new KanbanOfferStore(this.candidateService);
    kanban.changeFilters(status, 1, this.maxCandidates, this.jobId);
    kanban.statusName("Seleccionados");
    kanban.statusID(300);
    kanban.statusCustom(false);
    this.KanbanOfferStoreList.list.push(kanban);
    // this.offerStoreHired.changeFilters(status, 1, this.maxCandidates, this.jobId);
  }

  openDialogDelete(job,status) {
      let dialogRef = this.dialog.open(ConfirmDeleteDialogComponent);
      dialogRef.componentInstance.deleteOffer=true;
      dialogRef.componentInstance.OfferID=job.id;
      dialogRef.componentInstance.OfferStatus=status;
      dialogRef.afterClosed().subscribe(result => {
        if (result != "NO")
          job.status = -6;
      });
  }

  putOffersStatus(job, status) {
    this.jobService.putOffersStatus(job.id, status)
      .subscribe(
        data => {},
        error => this.errorMessage = <any>error
      );
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/view-job/view-job.component.ts